module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "chap02"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "chaptertitle"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "pt01ch02_p1"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARKER LAY")]), _vm._v(" in the dark on his hotel-room bed and waited to be contacted. Lying there, he looked like a machine not yet turned on. He was thinking about nothing; his nerves were still.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p2"
    }
  }, [_vm._v("When the knock sounded at the door, he got up and walked over and switched on the light, because he knew most people thought it strange when somebody lay waiting in the dark. Then he opened the door and there was a woman standing there, which he hadn't expected. She was tall and slender and self-possessed, with the face and figure of a fashion model, very remote and cool. She said, “Mr. Lynch?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p3"
    }
  }, [_vm._v("That was the name he was using here, but he said, “You sure this is the room you want?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p4"
    }
  }, [_vm._v("“May I come in?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p5"
    }
  }, [_vm._v("“Maybe you want some other Lynch,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p6"
    }
  }, [_vm._v("Her mouth showed impatience. “I really am from Billy Lebatard, Mr. Lynch,” she said. “And it would be better if we didn't talk in the hall.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p7"
    }
  }, [_vm._v("He shook his head. “Try another name.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p8"
    }
  }, [_vm._v("“You mean Lempke?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p9"
    }
  }, [_vm._v("“That's the one,” he said, and stepped back from the doorway, motioning her into the room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p10"
    }
  }, [_vm._v("She came in, still unruffled and self-possessed, saying, “Is all that caution really needed at this point?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p11"
    }
  }, [_vm._v("He shut the door. “I didn't expect a woman,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p12"
    }
  }, [_vm._v("“Oh? Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p13"
    }
  }, [_vm._v("“It's unprofessional.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p14"
    }
  }, [_vm._v("She smiled slightly, with one side of her mouth. “It doesn't sound like a very rewarding profession.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p15"
    }
  }, [_vm._v("Parker had no patience with pointless games. He shrugged and said, “What happens now?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p16"
    }
  }, [_vm._v("“I drive you to the meeting.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p17"
    }
  }, [_vm._v("“What meeting?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p18"
    }
  }, [_vm._v("She allowed herself to be surprised. “The meeting you're here for. Did you think you'd just do it without any plan at all?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p19"
    }
  }, [_vm._v("Parker hadn't yet decided whether or not he would do this one, but there was no point saying so; she was just a chauffeur. Besides, if she was any indication of how things would be handled here, he'd be out of it anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p20"
    }
  }, [_vm._v("But he would go to this first meeting, just to see the lay of the land. At the worst it was a chance to renew a couple of old touches. It was tough in this line of work to keep current with old friends, but the only way to build the right string for any job was to know who was available.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p21"
    }
  }, [_vm._v("So he slipped into his suit jacket, pocketed his room key, and said, “All right, we'll go have a meeting.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p22"
    }
  }, [_vm._v("They left the hotel and she led him around onto Washington Street and over to a green Buick station wagon, where she said, “Do you want to drive?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p23"
    }
  }, [_vm._v("“You know this town?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p24"
    }
  }, [_vm._v("She shrugged and made a face and said, “Fairly well.” As though what she meant was, more than I like.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p25"
    }
  }, [_vm._v("“Then you drive,” he said, and walked around to the passenger side and got in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p26"
    }
  }, [_vm._v("She looked after him in surprise, then opened the driver's door herself and slid in behind the wheel. She put the key in the ignition, but instead of starting the engine she sat back and began to study him, frowning to herself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p27"
    }
  }, [_vm._v("Parker waited, but she just kept sitting there and looking at him as though she was trying to read something written on the inside of his head, so after a while he said, “Okay, get it over with.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p28"
    }
  }, [_vm._v("“I'd just like to know,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p29"
    }
  }, [_vm._v("“Ask.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p30"
    }
  }, [_vm._v("“Are you just naturally rude, or are you trying to antagonize me for some reason?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p31"
    }
  }, [_vm._v("Parker shook his head. “All you do is drive the car.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p32"
    }
  }, [_vm._v("“In other words, I don't matter.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p33"
    }
  }, [_vm._v("“Right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p34"
    }
  }, [_vm._v("She nodded. “Fine by me,” she said. “It just took me by surprise, that's all.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p35"
    }
  }, [_vm._v("There was nothing to say to that, so Parker faced front and got out his cigarettes. He lit one for himself while she was starting the engine, and then sat back and watched Indianapolis slide by. It was a little after midnight of a Wednesday night and the streets were deserted. They were also very wide and very brightly lit, so it was like driving through a recently abandoned city, except that here and there neon lights flashed in the windows of closed drugstores and supermarkets. Parker watched all that emptiness outside the windshield, and it seemed to him this should be a good town for a late-night haul.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p36"
    }
  }, [_vm._v("It was good to be thinking right again. His mind had snapped into shape two days ago, the instant he'd heard Handy McKay's voice on the telephone, and he'd been cold and solid and sound ever since.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p37"
    }
  }, [_vm._v("The conversation had been brief, once the astonished and disgruntled divorcée had been gotten rid of. Handy said, “Ran into a pal of yours the other day. Lempke.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p38"
    }
  }, [_vm._v("That was a good name. Parker hadn't worked with Lempke in years, but he remembered him as reliable. He said, “How is he these days?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p39"
    }
  }, [_vm._v("“Keeping busy. He wanted to look you up sometime.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p40"
    }
  }, [_vm._v("“I'd like to see him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p41"
    }
  }, [_vm._v("“You could try a friend of his at the Barkley Hotel in Chicago.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p42"
    }
  }, [_vm._v("Parker, understanding that the friend was Lempke himself under an alias, said, “Maybe I will. What's the name?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p43"
    }
  }, [_vm._v("“Moore. John Moore.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p44"
    }
  }, [_vm._v("“Got it. You still retired?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p45"
    }
  }, [_vm._v("“Still and forever. Drop in sometime.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p46"
    }
  }, [_vm._v("“I will,” Parker said, knowing he wouldn't, and hung up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p47"
    }
  }, [_vm._v("The conversation with Lempke was even briefer. Not identifying himself, Parker said, “I was talking to Handy the other day. He said we might get together.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p48"
    }
  }, [_vm._v("“Not me,” said Lempke. “But a fella named Lynch might register at the Clayborn Hotel in Indianapolis on Wednesday. That might be something for you, if you're interested.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p49"
    }
  }, [_vm._v("“Thanks for the tip,” said Parker, and on Wednesday he'd arrived at the Clayborn Hotel in Indianapolis, registered under the name of Lynch, and waited.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p50"
    }
  }, [_vm._v("Now the waiting was done. He was surprised to be met by a woman, but with Lempke in it the job could still be good. The name she'd dropped—Billy Lebatard—meant nothing to him, and was unlikely to be another name of Lempke's, since Lempke knew enough not to use his own initials on new names.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p51"
    }
  }, [_vm._v("The woman drove at a fast and steady pace south-westward away from the center of town. The avenue narrowed, grew less brightly lit, more residential. There were no hills anywhere, nothing but flatness. Parker noticed the woman glance at him out of the corner of her eye as the cops went by.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p52"
    }
  }, [_vm._v("What did she expect him to do? Flinch, put his hands over his face, jump from the car and start running, pull out a pistol and bang away?")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pt01ch02_p53"
    }
  }, [_vm._v("He threw his cigarette out of the window, shut his eyes, and waited for the ride to stop.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17819060","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/part01chap02.vue
// module id = 78
// module chunks = 0